import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSales(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/sales', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchSale(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/sale/${id}/details`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        changeSaleState(ctx, { id, stateId }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/sale/${id}/change-state`, { stateId })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        reSyncOrder(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/orders/re-sync', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}